var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVehicle = function SvgVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.92 1.01C15.72.42 15.16 0 14.5 0h-11c-.66 0-1.21.42-1.42 1.01L0 7v7.5c0 .83.67 1.5 1.5 1.5S3 15.33 3 14.5V14h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5V7zM4.5 11C3.67 11 3 10.33 3 9.5S3.67 8 4.5 8 6 8.67 6 9.5 5.33 11 4.5 11m9 0c-.83 0-1.5-.67-1.5-1.5S12.67 8 13.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5M2.81 5l1.04-3h10.29l1.04 3z"
  })));
};
export default SvgVehicle;